// extracted by mini-css-extract-plugin
module.exports = {"search-lists":"searchBar_search-lists__3HFHg","position-relative":"searchBar_position-relative__1vSOr"};